<template>
  <v-container class="h-100vh d-flex align-center">
    <v-form class="form text-center" @submit="lc_login" ref="ref_login">
      <h2>Welcome Back</h2>
      <p>
        Don't miss your next opportunity. Sign in to stay updated on your
        professional world.
      </p>
      <div class="mt-10"></div>
      <v-alert
        type="error"
        border="left"
        class="mb-10"
        v-if="
          authNotification.message != '' && authNotification.type == 'error'
        "
        >{{ authNotification.message }}</v-alert
      >
      <v-text-field
        solo
        placeholder="Email"
        prepend-inner-icon="fa-user"
        v-model="data.email"
        :rules="[myrules.required, myrules.email]"
      ></v-text-field>
      <v-text-field
        solo
        type="password"
        placeholder="Password"
        prepend-inner-icon="fa-lock"
        v-model="data.password"
        :rules="[myrules.required]"
      ></v-text-field>
      <!-- <v-checkbox class="mt-0" :label="`Remember password`"></v-checkbox> -->
      <v-btn type="submit" block color="primary" :loading="authLoading">Sign in</v-btn>
      <div class="d-block d-md-flex mt-6">
        <router-link to="/forget-password">Forget Password?</router-link>
        <br class="d-block d-md-none" />
        <span class="ml-auto"
          >New to Lyricster PRO? <router-link to="/signup">Join Now</router-link></span
        >
      </div>
    </v-form>
    <v-dialog width="480px" v-model="modal">
      <img src="@/assets/confirmation_popup_after_payment.png"/>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Login",
  mounted(){
    let query = this.$route.query;
    if(Object.keys(query).includes("payment_success")){
      this.modal = true;
    }
  },
  data() {
    return {
      modal: false,
      data: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    lc_login(e) {
      e.preventDefault();
      let validate = this.$refs.ref_login.validate();
      if (validate) {
        this.login(this.data);
      }
    },
  },
};
</script>
<style scoped>
</style>